import {
  ACCIONES,
  ACCION_DESPLAZARSE,
  ACCION_ENLACE,
  ACCION_VIDEO,
  SECCIONES
} from 'utils/constants'
import { Form, Input, InputSelect } from 'components/Library'

/**
 * Componente que maneja la edición de acciones en landing pages.
 * @class
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.idioma - Idioma actual de la aplicación.
 * @param {Object} props.formValues - Objeto con los valores de los campos del formulario de la página.
 * @param {Function} props.handleInputChange - Callback para actualizar los valores de un elemento de la página.
 */
const MenuBenefits = ({ idioma, tipo, formValues, handleInputChange }) => {
  return (
    <Form
      style={{
        padding: '1rem'
      }}
    >
      <InputSelect
        name={`secciones.${tipo}.accion`}
        label="Acción"
        helper="Tipo de acción"
        options={ACCIONES}
        value={formValues.accion}
        onChange={handleInputChange}
      />
      {formValues.items.map((beneficio, index) => (
        <div key={index}>
          {+formValues.accion === ACCION_DESPLAZARSE.value && (
            <InputSelect
              name={`secciones.${tipo}.items.${index}.${idioma}.keyAccion`}
              label={`Sección (${beneficio[idioma].titulo})`}
              helper="Sección de la página a desplazarse"
              options={SECCIONES}
              value={formValues.items[index][idioma].keyAccion}
              onChange={handleInputChange}
            />
          )}
          {+formValues.accion === ACCION_ENLACE.value && (
            <Input
              name={`secciones.${tipo}.items.${index}.${idioma}.keyAccion`}
              label={`URL (${beneficio[idioma].titulo})`}
              helper="Enlace de la página para abrir al hacer click en el ícono"
              placeholder="https://guanabanapp.web.app/"
              value={formValues.items[index][idioma].keyAccion}
              onChange={handleInputChange}
            />
          )}
          {+formValues.accion === ACCION_VIDEO.value && (
            <Input
              name={`secciones.${tipo}.items.${index}.${idioma}.keyAccion`}
              label={`URL video (${beneficio[idioma].titulo})`}
              helper="Enlace del video para mostrar al hacer click en el ícono"
              placeholder="https://www.youtube.com/watch?v=Gu4na6an4pp"
              value={formValues.items[index][idioma].keyAccion}
              onChange={handleInputChange}
            />
          )}
        </div>
      ))}
    </Form>
  )
}

export default MenuBenefits
